import { render, staticRenderFns } from "./FileUploaderTransparent.vue?vue&type=template&id=37a85bd4&scoped=true"
import script from "./FileUploaderTransparent.vue?vue&type=script&lang=js"
export * from "./FileUploaderTransparent.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderTransparent.vue?vue&type=style&index=0&id=37a85bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a85bd4",
  null
  
)

export default component.exports